// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  store: store,
  components: { App }
})


// <template>
//   <div class="">

//   </div>
// </template>

// <script>

//   export default {
//     name: '',
//     props: [

//     ]
//   }
// </script>

// <style>

// </style>


// WEBPACK FOOTER //
// ./src/main.js